import React from 'react';

const Home = () => {
  return (
    <div className="home-return">
      <div className="home-img-container">
        <img className="home-img" alt="athletic ferrell" src="https://akns-images.eonline.com/eol_images/Entire_Site/2013113/rs_600x600-131203111000-600.Anchorman-2-Will-Ferrell-FHM-jmd-120313.jpg?fit=around%7C1200:1200&output-quality=90&crop=1200:1200;center,top" height="500" width="auto" />
      </div>
      <div className="footer-container">
        <footer>
          Developed with love by Bros.
        </footer>
      </div>
    </div>
  )
};

export default Home;